import { AppBar, Stack, Toolbar } from "@mui/material";
import React, { ReactElement } from "react";
import styled from "styled-components";

const StyledBottomBar = styled(AppBar)(({ theme }) => ({
  borderRadius: "0px 0px 10px 10px",
  boxShadow: "0px 1px 1px 0px rgba(0, 0, 0, 0.10) inset",
  display: "flex",
  alignContent: "flex-end",
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  background: "#FBFDFE",
  width: "100%",
  justifyContent: "center",
}));

const BottomBar: React.FC<{ buttons: ReactElement[], id?: string }> = ({ buttons, id }) => {
  return (
    <StyledBottomBar id={id} position="fixed" style={{ top: "auto", bottom: 0 }}>
      <StyledToolbar>
        <Stack direction="row" spacing={2} alignItems={"center"}>
          {buttons.map((button) => button)}
        </Stack>
      </StyledToolbar>
    </StyledBottomBar>
  );
};

export default BottomBar;
